var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.729,
    height: 39.342,
    viewBox: "0 0 54.729 39.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Education_1_copy_3",
    "data-name": "Education_1 copy 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64986",
    "data-name": "Path 64986",
    d: "M117.029,151.351a20.887,20.887,0,0,0-1.005-5.9l-.044-.131h-.131a49.839,49.839,0,0,0-22.95,4.109c7.912-4.809,14.251-5.945,21.944-6.207h.262l-.131-.219a20.847,20.847,0,0,0-3.5-5.114l-.087-.087-.087.044a55,55,0,0,0-20.545,12.24,1.585,1.585,0,0,1-2.186,0,55,55,0,0,0-20.545-12.24l-.087-.044-.087.087a24.69,24.69,0,0,0-3.5,5.114l-.131.219h.262c7.65.262,14.032,1.443,21.944,6.207a49.84,49.84,0,0,0-22.95-4.109h-.131l-.044.131a18.194,18.194,0,0,0-1.005,5.9v.175h.175a46.1,46.1,0,0,0,10.01-.918c4.546-.743,8.83-1.443,13.726-.219a.8.8,0,0,1,.612.787.69.69,0,0,0,.7.7h4.284a.69.69,0,0,0,.7-.7.84.84,0,0,1,.612-.787c4.9-1.224,9.18-.525,13.726.219a49.28,49.28,0,0,0,10.01.918h.175Z",
    transform: "translate(-62.3 -112.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64987",
    "data-name": "Path 64987",
    d: "M83.454,99.453A53.552,53.552,0,0,1,96,106.185a52.538,52.538,0,0,1,12.5-6.732V93.2a1.156,1.156,0,0,0-.568-1.005c-1.4-.831-5.158-2.142-11.934-2.142-5.552,0-9.092.874-10.928,1.661,2.186-1.4,6.994-2.361,12.721-2.361,7.825,0,11.715,1.224,11.715,3.541v1.836l9.049-4.24L95.956,80,73.4,90.491l10.01,4.634v4.328Z",
    transform: "translate(-68.548 -80)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIocn);
export default __webpack_public_path__ + "static/media/student-iocn.7f07737a408412a55fc77bb521d517e5.svg";
export { ForwardRef as ReactComponent };